module.exports = __webpack_public_path__ + "img/donante-el-mexicano.7df49e56.png";